import React from 'react';

import { PrimaryButton } from '@components/Button/variants';
import { useBlueconicContext } from '@contexts/BlueconicContext';
import useEventTracking from '@hooks/useEventTracking';
import { ClickTarget, click } from '@tracking';
import { captureBlueconicClickEvent } from '@utils/blueconic/utils';

interface CtaButtonModalBodyProps {
  buttonText: string;
  destinationUrl: string;
  disclosure?: string;
}

const CtaButtonModalBody = ({
  buttonText,
  destinationUrl,
  disclosure,
}: CtaButtonModalBodyProps) => {
  const { trackEvent } = useEventTracking();
  const { variantId } = useBlueconicContext();

  const handleClick = () => {
    trackEvent(
      click({
        clickLink: destinationUrl,
        clickTarget: ClickTarget.AnchorLink,
        clickText: buttonText,
      })
    );
    captureBlueconicClickEvent(variantId);
  };

  return (
    <div className="w-full">
      <PrimaryButton
        as="link"
        className="w-full"
        href={destinationUrl}
        onClickCapture={handleClick}
      >
        {buttonText}
      </PrimaryButton>
      {disclosure && (
        <p className="mb-0 mt-8 text-center font-suisse-screen text-body-sm text-grayscale-beige">
          {disclosure}
        </p>
      )}
    </div>
  );
};

export default CtaButtonModalBody;
